import { Navigate, useParams } from 'react-router-dom';
import AddEmployeePage from '../Admin/AddEmployeePage';

const SuperAdminAddEmployeePage = () => {
    const { siteId } = useParams<{ siteId: string }>();

    if (!siteId) {
        return <Navigate replace to="/admin/superadmin" />;
    }

    return (
        <AddEmployeePage
            tenantIdOverride={siteId}
            successPath={`/admin/superadmin/manage/${siteId}`}
        />
    );
};

export default SuperAdminAddEmployeePage;
